module.exports = __webpack_public_path__ + "img/emblem_6.a1fab95d.svg";